
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery-fees",
      function () {
        return require("private-next-pages/delivery-fees.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery-fees"])
      });
    }
  